import type { ReactNode } from 'react';

import { DebugBanner } from './DebugBanner';

export function DebugBannerContainer({
  debug,
  children,
}: {
  debug: boolean;
  children: ReactNode;
}) {
  return (
    <>
      {debug ? <DebugBanner /> : null}
      {children}
    </>
  );
}
